import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CommentForm from '../form/CommentForm';
import { getComments, deleteComment } from '../api';
import { authorizeUser } from '../../Login/api';
import { Icon, Text } from 'porosys-ui';
import moment from 'moment-jalaali';
import '../styles.scss';

const CommentList = props => {
    const { mentionedList, commentParentIndexes } = props;
    const history = useHistory();
    const [commentParent, setCommentParent] = useState([]);
    const [commentToEdit, setCommentToEdit] = useState(null);
    const [comments, setComments] = useState([]);
    const [logedInUser, setLogedInUser] = useState({});

    useEffect(() => {
        setComments(null);
        const fetchLogedInUser = async () => {
            setLogedInUser(await authorizeUser());
        };
        fetchLogedInUser();
    }, []);
    useEffect(() => {
        const splitedRoute = history.location.pathname.split('/');
        const indexes = commentParentIndexes ? commentParentIndexes : { title: 1, id: 2 };

        const parentTitle = splitedRoute[indexes.title];
        const parentId = splitedRoute[indexes.id];
        if (!parentId) return;
        setCommentParent([parentTitle, parentId]);

        const fetchComments = async () => {
            setComments(await getComments(parentTitle, parentId));
            scrollComments();
        };

        fetchComments();
    }, [history.location.pathname]);

    const localizeDate = date => {
        return moment(date).format('jYYYY/jMM/jDD HH:mm:ss');
    };
    const handleAddComment = comment => {
        setComments(comments => [
            ...comments,
            { ...comment, sender: { _id: logedInUser._id, fullname: logedInUser.fullname } },
        ]);
    };
    const handleUpdateComment = updatedComment => {
        const indexOfUpdatedComment = comments.findIndex(comment => comment._id === updatedComment._id);
        const updatedComments = [...comments];
        updatedComments[indexOfUpdatedComment] = updatedComment;
        setComments(updatedComments);
        setCommentToEdit(null);
    };
    const handleEditComment = comment => {
        setCommentToEdit(comment);
    };
    const handleDeleteComment = async commentIdToDelete => {
        await deleteComment(commentParent[0], commentParent[1], commentIdToDelete);
        const remainingComments = comments.filter(comment => {
            return comment._id !== commentIdToDelete;
        });

        setComments(remainingComments);
    };
    const handleCancelEdit = () => {
        setCommentToEdit(null);
    };
    const scrollComments = () => {
        const el = document.getElementById('e2');
        if (!el) return false;
        el.scrollTo({
            top: 10000,
            behavior: 'smooth',
        });
        return true;
    };
    return (
        <div className="comments-list">
            <div className="title">پیام ها</div>
            {comments && (
                <div className="list" id="e2">
                    {comments.map((comment, i) => (
                        <div
                            className={`comment-card ${logedInUser._id === comment.sender._id ? '' : 'recived'} `}
                            key={i}
                        >
                            <div id="header">{comment.sender.fullname}</div>

                            <div id="comment">{comment.text}</div>
                            <div id="footer" className="flex space-between">
                                {localizeDate(comment.createdAt)}
                                {logedInUser._id === comment.sender._id && (
                                    <div>
                                        <button onClick={() => handleEditComment(comment)} className="btn">
                                            <Icon fontSize={1} name="pen" />{' '}
                                        </button>
                                        <button
                                            className="btn delete-button"
                                            onClick={() => handleDeleteComment(comment._id)}
                                        >
                                            <Icon fontSize={1} name="trash" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <CommentForm
                commentParent={commentParent}
                handleCancelEdit={handleCancelEdit}
                mentionedList={mentionedList}
                commentToEdit={commentToEdit}
                handleAddComment={handleAddComment}
                handleUpdateComment={handleUpdateComment}
            />
        </div>
    );
};

export default CommentList;
